module.exports = __webpack_public_path__ + "img/img30.240864a5.png";